import gameInfo from '../assets/json/gameInfo.json'
import Phaser from 'phaser';
import gameData from './gameData.js';
import FontKeys from './FontKeys';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import { covertCreateJsAnimationsToPhaser } from './animations/createjsConversions';

const fonts = [];
for (let k in FontKeys)
{
    fonts.push(FontKeys[k]);
}

// note: uncomment or change the following based on what you need to load
ABCyaPhaser.Preloader.PreloaderConfig.fonts = fonts;
/**
 * To load multiple image sprites, change this property to an array of Phaser.Types.Loader.FileTypes.MultiAtlasFileConfig objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = [
 * { key: DEFAULT_ATLAS, atlasURL: PreloaderConfig.imagesPath + '/' + DEFAULT_ATLAS + '.json', path: PreloaderConfig.imagesPath }, // default multiatlas
 * { key: "particles", atlasURL: 'assets/images/particles.json', path: 'assets/images' }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.imagesPath = 'assets/images';
/**
 * To load multiple audio sprites, change this property to an array of Phaser.Types.Loader.FileTypes.AudioSpriteFileConfig objects.
 * Note: you should always include an ogg and mp3 file, the game will determine which to use based on compatibility. 
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = [
 * { key: DEFAULT_AUDIO_SPRITE, 
 *   jsonURL: PreloaderConfig.soundsPath + '/' + DEFAULT_AUDIO_SPRITE + '.json', 
 *   audioURL: [ PreloaderConfig.soundsPath + '/' + DEFAULT_AUDIO_SPRITE + '.ogg', PreloaderConfig.soundsPath + '/' + DEFAULT_AUDIO_SPRITE + '.mp3' ] }, // default sound sprite
 * { key: "extrasounds", jsonURL: 'assets/sounds/extrasounds.json', audioURL: [ 'assets/sounds/extrasounds.ogg', 'assets/sounds/extrasounds.mp3' ] }
 * ]
 */
ABCyaPhaser.Preloader.PreloaderConfig.soundsPath = 'assets/sounds';
/**
 * You can load spine objects here. This can be an object with key, jsonPath, and atlasPath properties, or an array of those objects.
 * Ex: ABCyaPhaser.Preloader.PreloaderConfig.spines = [
 * { key: "spine0", jsonPath: "assets/spines/spine0.json", atlasPath: "assets/spines/spine0.atlas" },
 * { key: "spine1", jsonPath: "assets/spines/spine1.json", atlasPath: "assets/spines/spine1.atlas" }
 * ]
 */
//ABCyaPhaser.Preloader.PreloaderConfig.spines = { key: "", jsonPath: "", atlasPath: "" };

ABCyaPhaser.Preloader.PreloaderConfig.startScene = gameData.startScene;

/**
 * Called when the preload function is done.
 * @param {Phaser.Scene} scene the preloader scene
 */
ABCyaPhaser.Preloader.PreloaderConfig.preloadCallback = scene =>
{
    // insert additional preloader functionality here; scene is the preloader scene
    scene.events.once(Phaser.Scenes.Events.CREATE, () => covertCreateJsAnimationsToPhaser(scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS)));
}

(async function handshake()
{
    try
    {
        await ABCyaLib.Environment.instance.doParentHandshake();
    } catch (error)
    {
        console.warn(error);
    }

    console.info("ABCya Game Info:", gameInfo);

    gameData.isMobile = !ABCyaLib.DEVICE_INFO.desktop ||
        ((ABCyaLib.Environment.instance.environment === ABCyaLib.Environment.ENVIRONMENTS.unknown ||
            ABCyaLib.Environment.instance.environment === ABCyaLib.Environment.ENVIRONMENTS.development) &&
            gameData.forceMobile);
    const gameWidth = gameData.isMobile ? 768 : 1024;
    const gameHeight = gameData.isMobile ? 1024 : 768;

    ABCyaPhaser.Misc.initializePhaserGame(gameWidth, gameHeight, gameData.scenes);
    ABCyaPhaser.Misc.initializeAbcyaLibDependencies(ABCyaLib);
})();
